<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="平台服务 " />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
          <img :src="cas.Img" />
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.Title}}</p>
            <p class="abstract-content">{{cas.Content}}</p>
            <div class="more">
              <!-- <router-link
                class="text-decoration"
                :to="{ name: 'casedetails', params: { id: cas.Id }}"
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
      caseList: [
        {
          Content:'善信医养智慧养老平台为老人提供上门服务、日间照料、老人餐厅、线上医生、旅居养老、康养基地等全方位、多层次养老服务，打造康养、旅居、社交娱乐为一体的一站式便捷智慧养老平台。',
          CreateTime: '2024年6月12日 17:44:29',
          Del:'',
          Id:'1',
          Img: require('../assets/img/FW_Phone.jpg'),
          Title:'善信医养APP',
        },
        {
          Content:'开放的服务平台，服务定价由市场决定，可自行选择自己满意的价格和服务，杜绝垄断性定价。智慧上门老年服务是一种全新的服务模式，它将先进的技术和智能化手段与老年人的实际需求相结合，为老年人提供更加便 捷、高效、个性化的服务。',
          CreateTime: '2024年6月12日 17:44:29',
          Del:'',
          Id:'1',
          Img: require('../assets/img/FW_TypePhone.jpg'),
          Title:'创新思维智慧服务',
        },
        {
          Content: '智慧上门老年服务是一种全新的服务模式，它将先进的技术和智能化手段与老年人的实际需求相结合，为老年人提供更加便 捷、高效、个性化的服务。',
          CreateTime: '2024年6月12日 17:44:29',
          Del:'',
          Id:'1',
          Img: require('../assets/img/FW_ShowHuan.jpg'),
          Title:'健康手环为老人、子女带来更便捷的生活',
        },

        {
          Content:'善信医养智慧养老平台为老人提供上门服务、日间照料、老人餐厅、线上医生、旅居养老、康养基地等全方位、多层次养老服务，打造康养、旅居、社交娱乐为一体的一站式便捷智慧养老平台。',
          CreateTime: '2024年6月12日 17:44:29',
          Del:'',
          Id:'1',
          Img: require('../assets/img/FW_ShuJu.png'),
          Title:'健康数据让子女更关心老人',
        },
        {
          Content:'平台为老人设立健康管理信息档案库，通过过往的病史和实时的检查数据，专业的医疗人员给老人制定专业化的疗养方案和治疗方案。通过健康一体机，用户可以实时监测自己的健康数据，如血压、血糖、心率等。手机APP 可以实时接收这些数据，并进行记录和分析，帮助用户更好地了解老人的健康状 况。',
          CreateTime: '2024年6月12日 17:44:29',
          Del:'',
          Id:'1',
          Img: require('../assets/img/FW_Jk.jpg'),
          Title:'健康一体机',
        },
      ]
    };
  },
  mounted() {
    
  }
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: rgb(255, 118, 64,0.9);
  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-around;
        align-items: center;
        border: 1px solid pink;
        box-sizing: border-box;
        padding: 20px 60px;
        img {
          width: 380px;
          height: 100%;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>